import React from "react";
// import "./Services.css";
import {
    handle_activePage,
} from '../../Redux/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

const Services = () => {
  const dispatch = useDispatch();
  return (
    <div className="services-container">
      {/* Hero Section */}
      <section className="hero">
        <h1>Our Digital Solutions</h1>
        <p>
          End-to-end services to grow your business online and offline.
        </p>
      </section>

      {/* Services Grid */}
      <section className="services-grid">
        <div className="service-card">
          <h2>Website Development</h2>
          <p>
            We design and develop responsive, SEO-friendly, and scalable
            websites that represent your brand and help you attract more
            customers.
          </p>
          <ul>
            <li>Modern & responsive design</li>
            <li>E-commerce & booking integration</li>
            <li>Domain & hosting setup</li>
            <li>Maintenance & support</li>
          </ul>
        </div>

        <div className="service-card">
          <h2>Social Media Marketing</h2>
          <p>
            Grow your online presence with targeted campaigns across social
            platforms.
          </p>
          <ul>
            <li>Strategy & content creation</li>
            <li>Paid ads management</li>
            <li>Analytics & reporting</li>
            <li>Brand storytelling</li>
          </ul>
        </div>

        <div className="service-card">
          <h2>Business WhatsApp Solutions</h2>
          <p>
            Leverage WhatsApp Business API to communicate directly with your
            customers.
          </p>
          <ul>
            <li>Automated replies & chatbots</li>
            <li>Bulk messaging dashboard</li>
            <li>CRM & lead management integration</li>
            <li>Verified business setup</li>
          </ul>
        </div>

        <div className="service-card">
          <h2>Billing Software Development</h2>
          <p>
            Custom billing and invoicing solutions tailored to your business
            needs.
          </p>
          <ul>
            <li>GST & tax compliance</li>
            <li>Inventory management</li>
            <li>Multi-device access</li>
            <li>POS / ERP integration</li>
          </ul>
        </div>
      </section>
       {/* Hero-Edu Section */}
      <section className="hero">
        <h1>Digital Education</h1>
        <p>
          Our online courses and curriculum are designed to make you a solid engineer.
        </p>
      </section>

      {/* Services Grid */}
      <section className="services-grid">
        <div className="service-card">
          <h2>Deep Learning course</h2>
          <p>
            A comprehensive two-month Deep Learning course that takes you from the basics to building real-world AI projects.
          </p>
          
          <Link   
            href="#DL_Course" 
            to='/DL_Course'
            onClick={()=>dispatch(handle_activePage("DL_Course"))}
        >
            <button className="cta-btn">Know More</button>
        </Link>
        </div>

      </section>

      {/* Call to Action */}
      <section className="cta">
        <h2>Let’s Build Your Next Solution</h2>
        
        <Link   
            href="#contact" 
            to='/contact'
            onClick={()=>dispatch(handle_activePage("contact"))}
        >
            <button className="cta-btn">Contact Us</button>
        </Link>
      </section>
    </div>
  );
};

export default Services;
